import React, { useState, useEffect } from 'react';
import '../assets/css/contact.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';

const Contact = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        services: '',
        projectDetails: '',
        agreement: false
    });

    const [status, setStatus] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatus('sending');

        // EmailJS Configuration
        // Replace these with your actual EmailJS credentials
        const serviceID = 'service_x8908os';      // EmailJS Dashboard 
        const templateID = 'template_rxhcu1g';    // EmailJS Dashboard 
        const publicKey = 'mWcILhzybMBYMyW9n';      // EmailJS Dashboard

        // Template parameters
        const templateParams = {
            from_name: formData.fullName,
            from_email: formData.email,
            phone: formData.phone,
            services: formData.services,
            project_details: formData.projectDetails,
            // to_email: 'manish.wcn@gmail.com',
            // reply_to: formData.email
        };

        emailjs.send(serviceID, templateID, templateParams, publicKey)
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                setStatus('success');
                setIsSubmitting(false);
                // Form reset
                setFormData({
                    fullName: '',
                    email: '',
                    phone: '',
                    services: '',
                    projectDetails: '',
                    agreement: false
                });
                // Success message 3 seconds के बाद hide करें
                setTimeout(() => setStatus(''), 3000);
            })
            .catch((error) => {
                console.error('FAILED...', error);
                setStatus('error');
                setIsSubmitting(false);
                // Error message 3 seconds के बाद hide करें
                setTimeout(() => setStatus(''), 3000);
            });
    };

    return (
        <>
            <div className="contact-page">
                {/* Breadcrumb Hero Section */}
                <section className="breadcrumb-hero">
                    <div className="breadcrumb-overlay"></div>
                    <div className="breadcrumb-content">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">

                                    <h1 className="breadcrumb-title">
                                        Contact Us
                                    </h1>
                                    <Link to="/services" style={{ textDecoration: 'none' }}>
                                        <button className="breadcrumb-btn">
                                            <span>OUR SERVICES</span>
                                            <span className="breadcrumb-arrow">
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </span>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="breadcrumb-pattern"></div>
                </section>
            </div>

            <section className="we-love-hearing-section">
                <div className="contact-header text-center">
                    <h2 className="contact-main-title" style={{ color: '#000' }}>Send Us a Message</h2>
                    <p className="contact-main-subtitle" style={{ color: '#000' }}>
                        Please fill in the form below to get in touch with us.
                    </p>
                </div>
                <div className="container">
                    <div className="row">
                        {/* Left Side - Contact Information */}
                        <div className="col-lg-5 col-md-12">
                            <div className="hearing-left-content">
                                <h2 className="hearing-main-title" style={{ color: '#000' }}>We Love Hearing From You!</h2>
                                <p className="hearing-subtitle" style={{ color: '#000', textAlign: 'left' }}>
                                    If you have any questions, please fill your queries in the form and we will respond as soon as we can.
                                </p>

                                <div className="hearing-contact-section">


                                    {/* Address */}
                                    <div className="hearing-contact-item">
                                        <div className="hearing-contact-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <div className="hearing-contact-text">
                                            <p>Gurgaon, Haryana, India</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Contact Form */}
                        <div className="col-lg-7 col-md-12">
                            <div className="hearing-form-wrapper">
                                <form onSubmit={handleSubmit} className="hearing-form">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="hearing-form-group">
                                                <label className="hearing-form-label">Full Name</label>
                                                <input
                                                    type="text"
                                                    name="fullName"
                                                    value={formData.fullName}
                                                    onChange={handleChange}
                                                    className="hearing-form-control"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="hearing-form-group">
                                                <label className="hearing-form-label">Email</label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    className="hearing-form-control"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="hearing-form-group">
                                                <label className="hearing-form-label">Phone</label>
                                                <input
                                                    type="tel"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    className="hearing-form-control"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="hearing-form-group">
                                                <label className="hearing-form-label">Services</label>
                                                <select
                                                    name="services"
                                                    value={formData.services}
                                                    onChange={handleChange}
                                                    className="hearing-form-control hearing-form-select"
                                                    required
                                                >
                                                    <option value="">Select Services</option>
                                                    <option value="web-development">Web Development</option>
                                                    <option value="mobile-app">Mobile App Development</option>
                                                    <option value="ui-ux">UI/UX Design</option>
                                                    <option value="consulting">IT Consulting</option>
                                                    <option value="cloud">Cloud Services</option>
                                                    <option value="ai-ml">AI & ML</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="hearing-form-group">
                                                <label className="hearing-form-label">About your project</label>
                                                <textarea
                                                    name="projectDetails"
                                                    value={formData.projectDetails}
                                                    onChange={handleChange}
                                                    className="hearing-form-control"
                                                    rows="2"
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    {status === 'success' && (
                                        <div className="alert alert-success mt-3" role="alert">
                                            ✅ Message sent successfully! We'll get back to you soon.
                                        </div>
                                    )}
                                    {status === 'error' && (
                                        <div className="alert alert-danger mt-3" role="alert">
                                            ❌ Failed to send message. Please try again later.
                                        </div>
                                    )}

                                    <div className="row">
                                        <div className="col-md-12">
                                            <button
                                                type="submit"
                                                className="hearing-submit-btn"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Sending...' : 'Send Us Message'}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    );
};

export default Contact;
